/**
 * Pricing JS - loads on Home and Pricing page
 */

import axios from 'axios'
import Pricing from '@siteminder/pricing-api'
import './anchor-scroll-offset.js'
import pageLang from '../util/pageLang.js'
import './slideinpopup.js'
import PopupTranslations from './translations/index.js'
import Close from '../../images/close.svg'

export default {
  init() {
    class Price {
      constructor(translations) {
        this.popuptranslations = PopupTranslations
        this.lang = pageLang
        this.policeCheck = window.policeCheck
        this.translations = translations
        this.$pricing = new Pricing()
        this.$pricing.init()
        this.subregion = null
        this.rooms = 5
        this.property = 1
        window.btnClick = function (e) {
          e.stopPropagation()
        }
        // slow as this is a promise, it needs the others init first
        this.endpoint = 'https://resources.siteminder.com/services/geo/index.php'
        this.request()


        let pricingPopupWrapper = document.querySelector('.features-popup-wrapper')
        if (pricingPopupWrapper && this.popuptranslations[this.lang].pricingPopups) {
          let code = ''
          let codeSetup = ''
          // let list
          let popups = this.popuptranslations[this.lang].pricingPopups
          popups.forEach((popup) => {
            code += `<div class="hidden invisible" id="${popup.id}">
              <div class="small section section--sm position-relative">
                <div class="container">
                  <div class="position-absolute feature-popup-close text-primary"><img src="${Close}" height="23" width="23"/>${popup.close}</div>
                  <div class="row">
                    <div class="col-lg-6 align-self-center text-left text-lg-center">
                      <div><img class="img-fluid rounded-8" src="${popup.img}" alt="" width="400" height="auto"></div>
                    </div>
                    <div class="col-lg-6 align-self-center pb-0">
                      <p class="h3 heading mb-4">${popup.title}</p>
                      <p class="medium mb-2">${popup.heading}</p>
                      ${popup.listLead ? `<p class="mb-0 medium">${popup.listLead}</p>`: ''}
                      <ul class="mb-2">${popup.list}</ul>
                      ${popup.list2Lead ? `<p class="mb-0 medium">${popup.list2Lead}</p>`: ''}
                      ${popup.list2 ? `<ul class="mb-3">${popup.list2}</ul>`: ''}
                      ${popup.note ? `<p class="fine-copy"><em>${popup.note}</em></p>` : ''}
                    </div>
                  </div>
                </div>
              </div>
            </div>`
            pricingPopupWrapper.innerHTML = code + codeSetup
            const pcheckElement = document.getElementById('pcheck');
            const notpcheckElement = document.getElementById('notpcheck');
            if (this.policeCheck) {
              if (pcheckElement) {
                pcheckElement.style.display = 'list-item';
                notpcheckElement.style.display = 'none';
              }
            } else {
              if (notpcheckElement) {
                notpcheckElement.style.display = 'list-item';
                pcheckElement.style.display = 'none';
              }
            }
          })
        }
      }

      request() {
        axios.get(this.endpoint)
          .then((response) => {
            if (response.data.request && response.data.request.status) {
              console.log('GeoIP API available')
              this.region = response.data.location.region.pricing.toLowerCase()
              this.country = response.data.location.country.code.toLowerCase()

              if (this.getTheRegion(this.country) == false) {
                if (this.region === 'uk') {
                  this.region = 'emea'
                  this.subregion = response.data.location.region.subregion
                  this.getThePrice(this.region, this.country, this.subregion)

                } else if (this.region === 'emea' || this.region === 'apac') { // pricing region emea pass subregion
                  this.subregion = response.data.location.region.subregion
                  this.getThePrice(this.region, this.country, this.subregion)

                } else { // subregion null for the red -- set at the top
                  this.getThePrice(this.region, this.country, this.subregion)
                }
              } else {
                this.region = this.getTheRegion(this.country)
                this.getThePrice(this.region, this.country, this.subregion)
              }
            } else {
              console.warn('GeoIP API unavailable. Defaulting request.')
              this.country = 'us'
              this.region = 'amer'
              this.getThePrice(this.region, this.country, this.subregion)
            }
          })
          .catch((e) => {
            console.warn('GeoIP API error. Defaulting request.', e)
            this.country = 'us'
            this.region = 'amer'
            this.getThePrice(this.region, this.country, this.subregion)
          })
      }

      // Custom regions
      getTheRegion(country) {
        const countryMap = {
          id: 'asiaidr',
          th: 'asiathb',
          my: 'asiadev',
        }
        return countryMap[country] || false
      }

      // Get the final price
      getThePrice(region, country, subregion) {
        // Initial quote when page loads for 5rooms
        let inputNumbers = document.querySelectorAll('.input-number')
        let roomInput = document.querySelector('.input-number.rooms')
        let propertyInput = document.querySelector('.input-number.property')
        if (roomInput) {
          this.rooms = parseInt(roomInput.value)
        }
        if (propertyInput) {
          this.property = parseInt(propertyInput.value)
        }
        this.bindPriceURLs(region, country, this.rooms, this.property, subregion)

        // Room and property inputs
        inputNumbers.forEach((inputNumber) => {
          inputNumber.addEventListener('keyup', () => {
            this.rooms = parseInt(roomInput.value)
            this.property = parseInt(propertyInput.value)
            if (!isNaN(this.rooms) && !isNaN(this.property)) {
              this.bindPriceURLs(region, country, this.rooms, this.property, subregion)
            }
          })
        })
      }

      bindPriceURLs(region, country, rooms, property, subregion) {
        this.quote(region, country, subregion)
        this.updateURL(rooms, property)
      }

      // Get the quote
      quote(region, country, subregion) {
        this.$pricing.ready(() => {
          const products = document.querySelectorAll('[data-field="product"]')
          products.forEach((product) => {
            const productname = product.getAttribute('id')
            var price = this.$pricing.lookups({
              rooms: this.rooms,
              product: productname,
              region: region,
              subregion: subregion,
              term: 'monthly',
              format: 'SHORT',
            }, 'products')
            const output = product.querySelector('.output')
            const priceTermsLHB = document.querySelectorAll('#term.lh-basics')
            const priceTermsLHPro = document.querySelectorAll('#term.lh-pro')
            const priceTermsLHPremium = document.querySelectorAll('#term.lh-premium')
            const priceTermsLHFlex = document.querySelectorAll('#term.lh-flex')

            if (this.property === 1) { // 1 property
              if (this.rooms === 0) {
                if (region === 'emea') {
                  if (subregion === 'United Kingdom') {
                    output.innerHTML = '£__'
                  } else {
                    output.innerHTML = '__ €'
                  }
                } else {
                  output.innerHTML = '$__'
                }
              } else {
                if (price === -1) {
                  if (output.classList.contains('lh-basics')) {
                    output.innerHTML = this.translations.notAvailable
                    priceTermsLHB.forEach((priceTermLHB) => {
                      if (priceTermLHB && !priceTermLHB.classList.contains('d-none')) {
                        priceTermLHB.classList.add('d-none')
                      }
                    })
                  } else {
                    output.innerHTML = this.translations.contactSales

                    priceTermsLHPro.forEach((priceTermLHPro) => {
                      if (priceTermLHPro && !priceTermLHPro.classList.contains('d-none')) {
                        priceTermLHPro.classList.add('d-none')
                      }
                    })

                    priceTermsLHPremium.forEach((priceTermLHPremium) => {
                      if (priceTermLHPremium && !priceTermLHPremium.classList.contains('d-none')) {
                        priceTermLHPremium.classList.add('d-none')
                      }
                    })

                    priceTermsLHFlex.forEach((priceTermLHFlex) => {
                      if (priceTermLHFlex && !priceTermLHFlex.classList.contains('d-none')) {
                        priceTermLHFlex.classList.add('d-none')
                      }
                    })
                  }
                } else {
                  priceTermsLHB.forEach((priceTermLHB) => {
                    if (productname === 'littleHotelierBasics' && priceTermLHB) {
                      priceTermLHB.classList.remove('d-none')
                    }
                  })
                  priceTermsLHPro.forEach((priceTermLHPro) => {
                    if (productname === 'littleHotelierPro' && priceTermLHPro) {
                      priceTermLHPro.classList.remove('d-none')
                    }
                  })

                  priceTermsLHPremium.forEach((priceTermLHPremium) => {
                    if (productname === 'littleHotelierPremium' && priceTermLHPremium) {
                      priceTermLHPremium.classList.remove('d-none')
                    }
                  })

                  priceTermsLHFlex.forEach((priceTermLHFlex) => {
                    if (productname === 'littleHotelierFlex' && priceTermLHFlex) {
                      priceTermLHFlex.classList.remove('d-none')
                    }
                  })
                  if (output.getAttribute('id') === 'output-lhbm'){
                    const codeEls = document.querySelectorAll('.code')
                    output.innerHTML = price + '&ast;'
                    if (region === 'emea') {
                      // No currency code for EMEA (EUR)
                      output.innerHTML = price + '&ast;'
                    } else if (region === 'asiaidr') {
                      output.innerHTML = this.formatNumberIDR(price) + '&ast;'
                    } else if (region === 'asiathb') {
                      output.innerHTML = this.formatNumber(price) + '&ast;'
                    } else {
                      output.innerHTML = price + '&ast;'
                      codeEls.forEach((el) => {
                        el.innerHTML = this.getRegionsCurrencyCode(region, country, subregion)
                      })
                    }
                  } else {
                    output.innerHTML = price
                    if (region === 'emea') {
                      // No currency code for EMEA (EUR)
                      output.innerHTML = price
                    } else if (region === 'asiaidr') {
                      output.innerHTML = this.formatNumberIDR(price)
                    } else if (region === 'asiathb') {
                      output.innerHTML = this.formatNumber(price)
                    } else {
                      output.innerHTML = price + '<span class="ml-2"><strong>' + this.getRegionsCurrencyCode(region, country, subregion) + '</strong></span>'
                    }
                  }

                  if (this.rooms > 30 && this.rooms <= 50) {
                    if (output.classList.contains('lh-basics')) {
                      output.innerHTML = this.translations.notAvailable
                      priceTermsLHB.forEach((priceTermLHB) => {
                        if (priceTermLHB && !priceTermLHB.classList.contains('d-none')) {
                          priceTermLHB.classList.add('d-none')
                        }
                      })
                    }
                  }
                }
              }
            } else {  // 1+ property
              if (output.classList.contains('lh-basics')) {
                output.innerHTML = this.translations.notAvailable
                priceTermsLHB.forEach((priceTermLHB) => {
                  if (priceTermLHB && !priceTermLHB.classList.contains('d-none')) {
                    priceTermLHB.classList.add('d-none')
                  }
                })
              } else {
                output.innerHTML = this.translations.contactSales

                priceTermsLHPro.forEach((priceTermLHPro) => {
                  if (priceTermLHPro && !priceTermLHPro.classList.contains('d-none')) {
                    priceTermLHPro.classList.add('d-none')
                  }
                })

                priceTermsLHPremium.forEach((priceTermLHPremium) => {
                  if (priceTermLHPremium && !priceTermLHPremium.classList.contains('d-none')) {
                    priceTermLHPremium.classList.add('d-none')
                  }
                })

                priceTermsLHFlex.forEach((priceTermLHFlex) => {
                  if (priceTermLHFlex && !priceTermLHFlex.classList.contains('d-none')) {
                    priceTermLHFlex.classList.add('d-none')
                  }
                })
              }
            }
          })

          // Dynamically add currency to LHB Booking Value Tooltip
          const lhbBkVtooltips = document.querySelectorAll('.lhbBkVTooltip')
          if (lhbBkVtooltips) {
            lhbBkVtooltips.forEach((tooltip) => {
              var tooltipContent = tooltip.innerHTML

              if (region === 'emea') {
              if (subregion !== 'United Kingdom') {
                tooltipContent = tooltipContent.replace(/\$1000/g, '1000 €');
                tooltipContent = tooltipContent.replace(/\$10/g, '10 €');
                tooltip.innerHTML = tooltipContent
              } else {
                tooltipContent = tooltipContent.replace(/\$/g, '£');
                tooltip.innerHTML = tooltipContent
              }
              } else if (region === 'asiaidr') {
                tooltipContent = tooltipContent.replace(/\$1000/g, this.formatNumberIDR('10000000'));
                tooltipContent = tooltipContent.replace(/\$10/g, this.formatNumberIDR('100000'));
                tooltip.innerHTML = tooltipContent
              } else if (region === 'asiathb') {
                tooltipContent = tooltipContent.replace(/\$1000/g, this.formatNumber('100000'));
                tooltipContent = tooltipContent.replace(/\$10/g, this.formatNumber('1000'));
                tooltip.innerHTML = tooltipContent
              }
            })
          }

          const signs = document.querySelectorAll('[data-field="sign"]')
          signs.forEach((sign) => {
            if (sign) {
              const outputSign = sign.querySelector('.output-sign')
              if (subregion === 'United Kingdom') {
                outputSign.innerHTML = '£'
              } else {
                outputSign.innerHTML = '$'
              }
            }
          })
        })
      }

      getRegionsCurrencyCode(region, country, subregion) {
        const codes = {
          apac: 'AUD',
          emea: 'EUR',
          asia: 'USD',
          asiaidr: 'IDR',
          asiathb: 'THB',
          amer: 'USD',
          uk: 'GBP',
          nz: 'NZD',
        }

        const EMEAUSDCountries = ['br']
        const IDRCountry = ['id']
        const THBCountry = ['th']
        if (subregion === 'United Kingdom') {
          return codes.uk
        } else if (EMEAUSDCountries.indexOf(country) >= 0) {
          return codes.amer // emeausd code is 'USD'
        } else if (IDRCountry.indexOf(country) >= 0) {
          return codes.asiaidr
        } else if (THBCountry.indexOf(country) >= 0) {
          return codes.asiathb
        } else if (subregion === 'New Zealand & Pacific') {
          return codes.nz
        } else {
          return codes[region] || codes.amer
        }
      }

      updateURL(rooms, property) {
        const triggers = document.querySelectorAll('.btn-pricing')
        triggers.forEach((trigger) => {
          if (property === 1) { // 1 property
            if (this.rooms === 0) {
              trigger.classList.add('disabled')
            } else if(this.rooms > 30 && this.rooms <= 50 ) {

              let product = trigger.getAttribute('data-product')

              if (product === 'basics') {

                trigger.innerHTML = this.translations.talkToUs
                trigger.classList.add('disabled')
              }
            } else if (this.rooms > 50) {
              trigger.classList.remove('disabled')
              trigger.addEventListener('click', (e) => {
                e.preventDefault()
                let product = trigger.getAttribute('data-product')
                let productinterest = trigger.getAttribute('data-product-interest')
                let url = this.translations.contactOver50Link
                location.href = url + '?l='+ this.lang + '&rooms=' + this.rooms + '&pr=' + property + '&p=' + product + '&r=' + this.rooms + '&productinterest=' + productinterest
              })

              if (trigger.classList.contains('btn-signup')) {
                trigger.innerHTML = this.translations.talkToUs
                let product = trigger.getAttribute('data-product')
                if (product === 'basics') {
                  trigger.innerHTML = this.translations.talkToUs
                  trigger.classList.add('disabled')
                }
              }
            } else {
              if (trigger.classList.contains('btn-signup')) { // LHB Market
                trigger.classList.remove('disabled')
                trigger.innerHTML = this.translations.getStarted
                let productinterest = trigger.getAttribute('data-product-interest')
                let product = trigger.getAttribute('data-product')
                let url = this.translations.signup
                trigger.addEventListener('click', (e) => {
                  e.preventDefault()
                  location.href = url + '?l='+ this.lang + '&rooms=' + this.rooms + '&pr=' + property + '&p=' + product + '&r=' + this.rooms + '&productinterest=' + productinterest
                })
              } else { // Rest of the world
                if (trigger.classList.contains('btn-signup')) {
                  trigger.classList.add('disabled')
                }
                trigger.classList.remove('disabled')
                trigger.addEventListener('click', (e) => {
                  e.preventDefault()
                  let product = trigger.getAttribute('data-product')
                  let productinterest = trigger.getAttribute('data-product-interest')
                  let url = this.translations.signup
                  location.href = url + '?l='+ this.lang + '&rooms=' + this.rooms + '&pr=' + property + '&p=' + product + '&r=' + this.rooms + '&productinterest=' + productinterest
                })
              }
            }
          } else { // If 1+ property
            if (trigger.classList.contains('btn-signup')) {
              let product = trigger.getAttribute('data-product')
              trigger.innerHTML = this.translations.talkToUs
              if (product === 'basics') {
                trigger.classList.add('disabled')
              }
            }
            if (this.rooms > 50) {
              let product = trigger.getAttribute('data-product')
              let productinterest = trigger.getAttribute('data-product-interest')
              trigger.addEventListener('click', (e) => {
                e.preventDefault()
                let url = this.translations.contactOver50Link
                location.href = url + '?l='+ this.lang + '&rooms=' + this.rooms + '&pr=' + property + '&p=' + product + '&r=' + this.rooms + '&productinterest=' + productinterest
              })
            } else {
              let product = trigger.getAttribute('data-product')
              let productinterest = trigger.getAttribute('data-product-interest')
              trigger.addEventListener('click', (e) => {
                e.preventDefault()
                let url = this.translations.contactSalesLink
                location.href = url + '?l='+ this.lang + '&rooms=' + this.rooms + '&pr=' + property + '&p=' + product + '&r=' + this.rooms + '&productinterest=' + productinterest
              })
            }
          }
        })
      }

      // formats currency IDR
      formatNumberIDR(price) {
        price = price.replace('Rp', '')
        price = parseInt(price, 10)
        return price.toLocaleString('id-ID', {
          style: 'currency',
          currency: 'IDR',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        })
      }

      // formats currency -- THB
      formatNumber(price) {
        price = price.replace('฿', '')
        price = parseInt(price, 10)
        return price.toLocaleString('th-TH', {
          style: 'currency',
          currency: 'THB',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        })
      }
    }
    const translations = window.pricingTranslations
    new Price(translations)
  },
  finalize() {},
};


// WEBPACK FOOTER //
// ./scripts/routes/pricing2024.js